<template>
    <div class="" @keyup.esc="showResults=false" >
     
          <div v-show="!inputOpen" @click="openInput"><i class="fa fa-search has-text-light searchInputs searchIcon handCursor"></i></div>
          
          <div v-show="inputOpen" class="searchInputs">
                <div class="searchInputsBG">
                  <div v-show="isLocal" class="bundleSearchLabel">&nbsp;</div>
                  <div class="searchX" @click="closeSearchInput"><i class="fa fa-chevron-right"></i></div>
                  <input class="input searchTextInput" type="text" v-model="terms"  @keyup.enter="callSearch"/>
                  
                <button class="button is-coolGreen is-small left-10 has-text-grey" style="z-index: 1" @click="callSearch"><i class="fa fa-search"></i></button>
                <i  class="fa fa-history has-text-grey-light handCursor showHistory left5 top5" @click="openHistory($event)"></i>
                <div v-show="isLocal && showResults" class="has-text-white is-size-7 top3 left35 handCursor hoverYellow" @click="searchGlobal">Search All Bundles</div>
                </div>
          </div>
          <button v-if="$route.path == '/extension'" class="button is-coolGreen is-small" style="position: absolute;top: 4px; left: 5px; z-index:2" @click="$parent.doItAgain"><i class="fa fa-arrow-left"></i></button>

          <div v-show="showSearchHistory" class="searchHistoryMenu">                     
                <div v-for="(s, ind) in history" :key="ind" class="handCursor" @click="setSearchTerm(s)">
                    {{s}}
                </div>
                <div v-if="history.length == 0">no history</div>
          </div>
         
         
      <div v-show="showResults" class="searchResBG searchResultsPanel has-text-white">
       
        <div ref="scroller" class="resultsDiv posRelative" style=" overflow: scroll; pointer-events: auto">
           <!--  <div id="xButt" class="delete top-15" @click="closeSearch"></div> -->

            <div class="is-inline-block" style="position: absolute; right: 50px; top:40px" id="spinnerTgt"></div>
          <br>

          <i id="xButt" class="delete top-20  left5  handCursor"  @click="closeSearchInput"></i>
          <div class="is-size-3 top40">
            <div class="is-inline-block has-background-dark searchingLabel right10">SEARCHING</div><img src="@/assets/img/fourDotsLogo.png" width="24"/>
            <b v-if="isLocal" class=" left7">{{localPayload.listName}}</b>
            <b v-if="!isLocal" class=" left7">All Bundles</b>
            <br>
            <button v-show="isLocal && (myCards.length || collabCards.length)" class="button is-small is-coolGreen" @click="selectInBundle">SELECT IN BUNDLE</button>
          </div>

          <div v-show="!mBundleRes.length && !cBundleRes.length && !pBundleRes.length && !myCards.length && !collabCards.length && !publicCards.length" class="top40">No Results</div>
 
          <div  class="top10">
           <div  v-show="(detail == 0 || detail < 4) && (mBundleRes.length || cBundleRes.length || pBundleRes.length)" class="is-size-3"><b>bundles</b></div>
  
           <div v-show="(detail==0 || detail == 1) && mBundleRes.length" class="posRelative">
              <b class="has-background-coolGreen has-text-dark pad5">my bundles</b>
              <div class="viewMore" @click="enterDetail(1)">{{detail == 0 ? 'View More' : 'Back'}}</div>
              <div v-for="(i) in mBundleRes" :key="i.id">
                  <div class="is-inline-block has-background-black top10 handCursor" style="padding-right: 5px; border-top-right-radius: 8px" @click="openLocalBundle(i.rootId, i.rootId)">
                      <div class="is-inline-block has-text-coolGreen" >&nbsp;<b>::</b></div>
                      <span class="is-size-6 has-text-white"><b> {{i.rootName}}</b></span>
                  </div>
                  <i v-if="i.rootId != i.id" class="fa fa-arrow-right left3"></i>
                  <div v-if="i.rootId != i.id" class="is-inline-block handCursor"  @click="openLocalBundle(i.rootId, i.id)"><div class="is-inline-block has-text-coolGreen handCursor is-size-5 ">&nbsp;<b>::</b></div><span class="is-size-6"><b> {{i.listName}}</b></span> </div>
              </div>
                <div v-if="mBundleRes.length == 0">none</div>
              <br>
           </div>
  
           <div v-show="(detail== 0 || detail == 2) && cBundleRes.length" class="posRelative">
              <b class="has-background-coolGreen has-text-dark pad5">collab bundles</b>
              <div class="viewMore" @click="enterDetail(2)">{{detail == 0 ? 'View More' : 'Back'}}</div>
              <div v-for="(l) in cBundleRes" :key="l.id">
                  <div class="is-inline-block has-background-black top10 handCursor" style="padding-right: 5px; border-top-right-radius: 8px" @click="openLocalBundle(l.rootId, l.rootId)">
                    <div class="is-inline-block has-text-coolGreen handCursor  ">&nbsp;<b>::</b></div>
                    <span class="is-size-6 has-text-white"><b> {{l.rootName}}</b></span>
                   </div>
                  <i v-if="l.rootId != l.id" class="fa fa-arrow-right left3"></i>
                  <div v-if="l.rootId != l.id" class="is-inline-block handCursor"  @click="openLocalBundle(l.rootId, l.id)"><div class="is-inline-block has-text-coolGreen handCursor is-size-5 ">&nbsp;<b>::</b></div><span class="is-size-6"><b> {{l.listName}}</b></span> </div>
              </div>
                <div v-if="cBundleRes.length == 0">none</div>
              <br>
           </div>
  
  
          <div v-show="(detail== 0 || detail == 3) && pBundleRes.length" class="posRelative">
            <b class="has-background-coolGreen has-text-dark pad5">public bundles</b>
            <div class="viewMore" @click="enterDetail(3)">{{detail == 0 ? 'View More' : 'Back'}}</div>
            <div v-for="(x) in pBundleRes" :key="x.id">
              <div class="is-inline-block has-background-black top10 handCursor"  @click="openPubBundle(x.mCode)" style="padding-right: 5px; border-top-right-radius: 8px">
                <div class="is-inline-block has-text-coolGreen handCursor">&nbsp;<b>::</b></div>
                <span class="is-size-6 has-text-white"><b> {{x.rootName}}</b></span>
              </div>
              <i v-if="x.rootId != x.id" class="fa fa-arrow-right left3"></i><div v-if="x.rootId != x.id" class="is-inline-block ">
              <div class="is-inline-block handCursor" @click="openPubBundle(x.mCode)">
                <div class="is-inline-block has-text-coolGreen is-size-5">&nbsp;<b>::</b></div>
                <span class="is-size-6"><b> {{x.listName}}</b></span> </div> 
              </div>
            </div>
              <div v-if="pBundleRes.length == 0">none</div>
          </div>
          </div>

    <!--- miimus --->
            <br> 
            <div v-show="(detail == 0 || detail > 3) && (myCards.length || collabCards.length || publicCards.length)"><b  class="is-size-3">miimus</b>&nbsp;&nbsp;&nbsp;<span class="has-text-coolGreen handCursor" @click="toggleShowLocations">{{showLocations ? 'hide' : 'show'}} locations</span></div>
           
           
           <div v-show="(detail== 0 || detail == 4) && myCards.length" class="posRelative">
              <b class="has-background-coolGreen has-text-dark pad5">my miimus</b>
              <div class="viewMore" @click="enterDetail(4)">{{detail == 0 ? 'View More' : 'Back'}}</div>  
            <div v-for="(c) in myCards" :key="c.id" style="border-left: 4px solid #FC9">
  
                <a  :href="c.url" target="_blank">
                   <table class="searchResTable top5"  style="border: 1px solid #555; width: 100%" >
                        <tr class="searchTableTR">
                            <td width="9%" style="line-height: .5rem" >
                                <div class="hUrlCardImgContainer">
                                    <img class="" :src="c.img"/>
                                </div>
                            </td>
                            <td width="46%">
                                <div class="is-size-6 tdEllipsis has-text-white">&nbsp;{{c.title}} </div> 
                            </td>
                            <td width="40%">
                                <div class="is-size-6 tdEllipsis has-text-white"><b>| {{c.site}}</b> </div> 
                            </td>
                            <td width="5%" align="right">
                                <button v-if="$route.fullPath != '/extension'" class="button is-coolGreen tiny right5 top1" @click.prevent="openCard(c.id, undefined, c.collabId, ...arguments)" :id="'editBtn' + c.id">EDIT</button>
                            </td>
                        </tr>
                    </table> 
                </a>
  
                <div v-show="showLocations" class="left27">
                    <div v-for="(n, ite) in c.items" :key="ite"  :class="{top4: !(n.rootId != n.parentId)}" >
                        <div class="is-inline-block has-background-black handCursor" style="padding-right: 5px; border-top-right-radius: 8px" @click="openLocalBundle(n.rootId, n.rootId)">
                          <div class="is-inline-block has-text-coolGreen  ">&nbsp;<b>::</b></div>
                          <span class="is-size-7 has-text-white"><b> {{n.rootName}}</b></span>
                        </div>
                        <i v-if="n.rootId != n.parentId" class="fa fa-arrow-right left3"></i>
                        <div v-if="n.rootId != n.parentId" class="is-inline-block handCursor" @click="openLocalBundle(n.rootId, n.parentId)">
                          <div class="is-inline-block has-text-coolGreen  is-size-5 ">&nbsp;<b>::</b></div>
                          <span class="is-size-6"><b> {{n.parentName}}</b></span> 
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="myCards.length == 0">none</div>
  
  
  
            <br>
           </div>


          <div v-show="(detail== 0 || detail == 5) && collabCards.length" class="posRelative">
            <b class="has-background-coolGreen has-text-dark pad5">collab miimus</b> 
            <div class="viewMore" @click="enterDetail(5)">{{detail == 0 ? 'View More' : 'Back'}}</div> 
            <div v-for="(cl) in collabCards" :key="cl.id" style="border-left: 4px solid #FC9" >
              <a  :href="cl.url" target="_blank">
                <table class="searchResTable top5"  style="border: 1px solid #555; width: 100%">
                      <tr class="searchTableTR">
                          <td width="9%" style="line-height: .5rem">
                              <div class="hUrlCardImgContainer">
                                  <img class="" :src="cl.img"/>
                              </div>
                          </td>
                          <td width="46%">
                              <div class="is-size-6 tdEllipsis has-text-white">&nbsp;{{cl.title}} </div> 
                          </td>
                          <td width="40%">
                              <div class="is-size-6 tdEllipsis has-text-white"><b>| {{cl.site}}</b> </div> 
                          </td>
                          <td width="5%" align="right">
                              
                              <button  v-if="$route.fullPath != '/extension'" class="button is-coolGreen tiny right5 top1" @click.prevent="openCard(cl.id, undefined, cl.collabId, ...arguments)" :id="'editBtn' + cl.id">EDIT</button>
                          </td>
                      </tr>
                  </table> 
                  </a>
                  
                <div  v-show="showLocations" class="left27">
                    <div v-for="(n, ite) in cl.items" :key="ite" :class="{top4: !(n.rootId != n.parentId)}" >
                        <div class="is-inline-block has-background-black handCursor" style="padding-right: 5px; border-top-right-radius: 8px" @click="openLocalBundle(n.rootId, n.rootId)">
                          <div class="is-inline-block has-text-coolGreen handCursor ">&nbsp;<b>::</b></div>
                          <span class="is-size-7 has-text-white"><b> {{n.rootName}}</b></span>
                        </div>
                        <i v-if="n.rootId != n.parentId" class="fa fa-arrow-right left3"></i>
                        <div v-if="n.rootId != n.parentId" class="is-inline-block handCursor" @click="openLocalBundle(n.rootId, n.parentId)">
                          <div class="is-inline-block has-text-coolGreen handCursor is-size-5 ">&nbsp;<b>::</b></div>
                          <span class="is-size-6"><b> {{n.parentName}}</b></span> 
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="collabCards.length == 0">none</div>
  
  
              <br>
          </div>


         <div v-show="(detail== 0 || detail == 6) && !isLocal && publicCards.length" class="posRelative">
            <b class="has-background-coolGreen has-text-dark pad5">public miimus</b>  
            <div class="viewMore" @click="enterDetail(6)">{{detail == 0 ? 'View More' : 'Back'}}</div>
            <div v-for="(p) in publicCards" :key="p.id" style="border-left: 4px solid #FC9">
              <a  :href="p.url" target="_blank">
                <table class="searchResTable top5"  style="border: 1px solid #555; width: 100%">
                      <tr class="searchTableTR">
                          <td width="9%" style="line-height: .5rem">
                              <div class="hUrlCardImgContainer">
                                  <img class="" :src="p.img"/>
                              </div>
                          </td>
                          <td width="46%">
                              <div class="is-size-6 tdEllipsis has-text-white">&nbsp;{{p.title}} </div> 
                          </td>
                          <td width="40%">
                              <div class="is-size-6 tdEllipsis has-text-white"><b>| {{p.site}}</b> </div> 
                          </td>
                          <td width="5%" align="right" class="posRelative">
                            <!-- <div class="is-inline-block" style="position: absolute; right: 10px; top: 0px">
                                  <div v-if="p.collapsed" class="vAlignTop top5 right3 has-text-coolGreen  handCursor" @click="expandPCard(ite)">
                                      <i class="fas fa-caret-right"></i>
                                  </div>
                  
                                  <div v-if="!p.collapsed" class="vAlignTop top2  has-text-coolGreen left5 handCursor" @click="collapsePCard(ite)" >
                                      <i class="fas fa-sort-down"></i>
                                  </div>
                            </div> -->
                            <button class="button is-coolGreen tiny right5 top1" @click.prevent="importIt(p.id, ...arguments)" :id="'editBtn' + p.id">IMPORT</button>
                          </td>
                      </tr>
                  </table> 
                  </a>
                <div  v-show="showLocations" class="left27">
                    <div v-for="(k, ite) in p.items" :key="ite"  :class="{top4: !(k.rootId != k.parentId)}" >
                        <div class="is-inline-block has-background-black handCursor" style="padding-right: 5px; border-top-right-radius: 8px" @click="openPubBundle(k.mCode)">
                          <div class="is-inline-block has-text-coolGreen">&nbsp;<b>::</b></div>
                          <span class="is-size-7 has-text-white"><b> {{k.rootName}}</b></span>
                        </div>
                        <i v-if="k.rootId != k.parentId" class="fa fa-arrow-right left3"></i>
                        <div v-if="k.rootId != k.parentId" class="is-inline-block handCursor" @click="openPubBundle(k.mCode)">
                          <div class="is-inline-block has-text-coolGreen handCursor is-size-5 ">&nbsp;<b>::</b></div>
                          <span class="is-size-6"><b> {{k.parentName}}</b></span> 
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="publicCards.length == 0">none</div>
             <br>
         </div>

          <div v-show="detail > 0 && showLoadMore" class="has-text-centered handCursor has-text-coolGreen" :class="{'is-loading' : isLoading, 'top-20': detail < 4}" @click="doDetailSch"><b>{{!isLoading ? 'Load More' : ''}}</b></div>
        
        </div>
       
      </div>
</div>

</template>

<script>

import { AZEventBus } from '../components/AZEventBus'

export default{
  name: 'search',
  components: {},

  data: function(){
    return {
      keywords: '',
      results: [],
      showResults: false,
      terms: '',
      myCards: [],
      collabCards: [],
      publicCards: [],
      mBundleRes: [],
      cBundleRes: [],
      pBundleRes: [],
      showLocations: false,
      detail: 0,
      limit: 20,
      offset: 0,
      isLoading: false,
      showLoadMore: true,
      inputOpen: false,
      localPayload: {},
      isLocal: false,
      showSearchHistory: false,
      history: [],    
    } 
  },

  mounted: function(){
    var self = this;
    //get search history

    AZEventBus.$on('closeAllMenus', this.closeAllMenusHandler)  

  },

  beforeDestroy: function(){
    var self = this;
    AZEventBus.$off('closeAllMenus', this.closeAllMenusHandler)  
  },

  methods:{

    doDel: function(obj){ 
      var self = this; 
      this.$root.app.deleteCard(obj.id) //passthrough for modalEdit calling doDel from 'caller'
      setTimeout(function(){
        self.myCards = self.myCards.filter(e => {
          return e.id != obj.id
        })

        self.collabCards = self.collabCards.filter(e => {
          return e.id != obj.id
        })

        self.publicCards = self.publicCards.filter(e => {
          return e.id != obj.id
        })
      }, 5)

      
      
    },

    closeAllMenusHandler: function(msg){
      this.showSearchHistory = false
    },

    selectInBundle: function(){
      if(this.myCards.length == 0 && this.collabCards.length == 0){

        return
      }

      var arr = []
        this.myCards.forEach(e => {
          arr.push(e.id)
        })

        this.collabCards.forEach(e => {
          arr.push(e.id)
        })

        this.localPayload.localBundle.startSelectFromSearch(arr)

        //if(this.$root.app.inApp)
          this.closeSearchInput()
    

    },

    callSearch: function(){

      //this.$refs.scroller.scrollTo(0,0)
      
      var self = this;
      self.detail = 0;
      self.offset = 0;
      self.showResults = true;
      this.showLoadMore = true;
      self.mBundleRes.splice(0)
      self.cBundleRes.splice(0)
      self.pBundleRes.splice(0)
      self.myCards.splice(0)
      self.collabCards.splice(0)
      self.publicCards.splice(0)
      
      
      function w(d){  
        az.addRemSpinner(false, "id", "spinnerTgt")
        
        d.c.forEach(e => {
          
            var objs = []
            var pn = e.parentNames.split('|')
            var p  = e.parents.split(',')
            var rn  = e.rootNames.split('|')
            var r  = e.roots.split(',')
            

            var m = []
            var h = []
            if(e.mCodes)  
              m = e.mCodes.split(',')
            if(e.handles)
              h  = e.handles.split(',')
           
            r.forEach((i, ind) => {
              var o = {parentId: '', parentName:'', rootId:'', rootName:'', mCode: "", handle: ""}
              o.parentId = parseInt(p[ind]);
              o.parentName = pn[ind]; 
              o.rootId = parseInt(r[ind]);
              o.rootName = rn[ind];
              o.mCode = m[ind] || null;
              o.handle = h[ind] || null;
              objs.push(o)
            })
            
            e.items = objs;
        })

           

        self.myCards = d.c.filter(e => {
          return e.isMine 
        })
        self.myCards.splice(5)

        self.collabCards = d.c.filter(e => {
          return !e.isMine && e.collabId
        })
        self.collabCards.splice(5)

        self.publicCards = d.c.filter(e => {
          return e.isPublic && !e.isMine
        })
        self.publicCards.forEach(g => {
          g.collapsed = true;
        })
        self.publicCards.splice(5)

   


        self.mBundleRes = d.b.filter(e => {
          return e.collabId == null && e.isMine
        })
        self.mBundleRes.splice(5)

        self.cBundleRes = d.b.filter(e => {
          return e.collabId != null
        })
        self.cBundleRes.splice(5)

        self.pBundleRes = d.b.filter(e => {
          return e.isPublic == 1 && !e.isMine
        })
        self.pBundleRes.splice(5)
        
       
      }

      function n(){
        az.addRemSpinner(false, "id", "spinnerTgt")
        //alert('error')
      }
      az.addRemSpinner(true, "id", "spinnerTgt")
      
      if(!this.isLocal){
        this.$root.app.apiClient.post('subs/data/sch', {s: this.terms.trim(), ext: this.ext}, w, n);
      } else {
        this.$root.app.apiClient.post('/subs/data/localsch', {id: this.localPayload.id, collabId: this.localPayload.collabId, s: this.terms.trim(), rootId: this.localPayload.rootId}, w, n)
      }
    },
    

    closeSearch: function(){
      this.showResults = false
      this.$parent.$refs.bundlesContent1.classList.remove('bgBlur')
      this.$parent.$refs.bundlesContent2.classList.remove('bgBlur')
    },

    doLocalSearch: function(){
        this.terms = this.localPayload.terms
        this.callSearch()
    },



    closeSearchInput: function(){
      this.inputOpen = false; 
      this.showResults = false
      this.terms = ''
    },

/*     edit: function(cardsIndex, bundleId, event){
        event.stopPropagation()
        this.$root.app.doShowModal('editModal', {url: '', cardsIndex: cardsIndex, callApi: false, caller: this, bundleId: bundleId})
    },
 */
    navigate(url){
  
        window.open(url);
    },

    toggleShowLocations: function(){
      this.showLocations =  !this.showLocations
    },

    openLocalBundle: function(rootId, id){
      var self = this
 
      var waitTime = 20

     
      
      if(this.$root.app.fulled){
        this.$root.app.fulled = false
        waitTime = 20
      }

      if(this.$root.app.currBundleGroup != 'All'){
        this.$root.app.$refs.routerView.viewChanged(0)
        waitTime = 20
      }

      var b = this.$root.app.treeNoInbox.find(e => {
         return e.rootId == rootId || e.aliasTgtId == rootId
      })

      if(window.innerWidth < 600){
        this.showResults = false
      }

      setTimeout(function(){
        self.$parent.getIndexOfRootBundle(id, b.rootId)
        if(self.$root.app.inApp && self.$root.app.$refs.routerView.inbox){
          self.$root.app.$refs.routerView.toggleInbox()
        }
      }, waitTime)

      
     

     
     
     
      

       
      /*  var listIndex = 0
       var isAlias = false
       var b = this.$root.app.treeNoInbox.find(e => {
         return e.aliasTgtId == rootId || e.id == rootId
       })
       
       var newRootId = b.id
       if(b.collabId && b.aliasTgtId == id){
         id = b.id
       }

       this.$root.app.$refs.routerView.$refs.rootBundleContainers.forEach((e, i) => {
         if(e.data.id == rootId || e.data.aliasTgtId == rootId){
           listIndex = i
         }
       })

       this.$parent.openWindow(id, listIndex, newRootId) */

    },

     openPubBundle: function(mCode){
        //this.$router.push({name: 'profiledelegate', params: {propProfile: p, propMCode: mCode, deep: deep}})
        this.$root.app.doShowModal('ModalBundle', {mCode: mCode})
     },

     searchGlobal: function(){
        this.isLocal = false
        this.callSearch()

     },

     openHistory: function(e){
       var self =  this

        e.preventDefault()
        e.stopPropagation()
        this.showSearchHistory = true

        function w(d){
          if(d)
            self.history = d
        }

        function n(){}

        self.$root.app.apiClient.get('subs/data/schhistory', {}, w, n)
             
     },

     setSearchTerm: function(s){
        this.terms = s
     },

     openCard: async function(id, bundleId, collabId, event){

            event.stopPropagation()

            if(id == 'removed'){
                this.$root.app.showModalOK({message: 'This miimu has been removed by its contributor.'})
                return
            }
            
            var ind = this.$root.app.cards.findIndex(e => {
                return e.id == id
            })

            if(ind == -1){
               
                //make call to get 
                az.addRemSpinner(true, "id", "editBtn" + id)
                await this.$root.app.loadOneCard(id + '-pub')
                az.addRemSpinner(false, "id", "editBtn" + id)
                

                ind = this.$root.app.cards.findIndex(e => {
                    return e.id == id
                })

            }

            //is Edited, must find a bundle that contains it
            if(bundleId == undefined){
                var arr = this.$root.app.bundles.filter(e => {
                    return e.collabId == collabId
                })
                
                for(var i=0; i<arr.length; i++){
                    for(var x=0; x < arr[i].items.length; x++){
                        if(arr[i].items[x].id == id){
                            bundleId = arr[i].id;
                            break
                        }
                    }
                }
               
            }
            
            this.$root.app.doShowModal('editModal', {url: '', cardsIndex: ind, callApi: false, caller: this, bundleId: bundleId, collabIdFromUrlCard: collabId, cardId: id})
          //this.$root.app.doShowModal('editModal', {url: '', cardsIndex: this.cardsIndex, callApi: false, caller: this, bundleId: this.$parent.conts.aliasTgtId || this.$parent.conts.id, collabIdFromUrlCard: this.$parent.conts.collabId, goToNotes: goToNotes})
        },

        importIt: function(id, event){

          event.stopPropagation()

          var self = this
 

          function w(d){
            self.$root.app.doShowModal('editModal', {cardPack: d.response.cards[0], callApi: false})
          }

          function n(){

          }
          self.$root.app.apiClient.get('subs/data/card/' + id + '-pub', {}, w, n)
        },

        enterDetail: function(val){
          if(this.detail > 0){  //back button clicked
            
            this.detail = 0;
            this.offset = 0;
            this.showLoadMore = true;
            if(this.mBundleRes.length > 0)
              this.mBundleRes.splice(5)
            if(this.cBundleRes.length > 0)
              this.cBundleRes.splice(5)
            if(this.pBundleRes.length > 0)
              this.pBundleRes.splice(5)
            if(this.myCards.length > 0)
              this.myCards.splice(5)
            if(this.collabCards.length > 0)
              this.collabCards.splice(5)
            if(this.publicCards.length > 0)
              this.publicCards.splice(5)
           
            return
          }

          this.detail = val

          this.doDetailSch(val)
        },

        doDetailSch: function(val){
          //this.$refs.scroller.scrollTo(0,0)
          var self = this;


          function w(d){
             self.isLoading = false;
           
            if(d.b && d.b.length == 0 && self.detail < 4 && detail > 0 && self.offset > 0){
              self.showLoadMore = false;
              return
            } else if(d.c && d.c.length == 0 && self.detail > 3 && self.offset > 0){
              self.showLoadMore = false;
              return
            }

            if(d.c){
              d.c.forEach(e => {
            
                  var objs = []
                  var pn = e.parentNames.split('|')
                  var p  = e.parents.split(',')
                  var rn  = e.rootNames.split('|')
                  var r  = e.roots.split(',')
                  

                  var m = []
                  var h = []
                  if(e.mCodes)  
                    m = e.mCodes.split(',')
                  if(e.handles)
                    h  = e.handles.split(',')
                
                  r.forEach((i, ind) => {
                    var o = {parentId: '', parentName:'', rootId:'', rootName:'', mCode: "", handle: ""}
                    o.parentId = parseInt(p[ind]);
                    o.parentName = pn[ind]; 
                    o.rootId = parseInt(r[ind]);
                    o.rootName = rn[ind];
                    o.mCode = m[ind] || null;
                    o.handle = h[ind] || null;
                    objs.push(o)
                  })
                  
                  e.items = objs;
              })
            }
           
            if(self.detail == 1 ){
              if(self.offset == 0)
                self.mBundleRes.splice(0)
              self.mBundleRes = self.mBundleRes.concat(d.b)
            } else if(self.detail == 2){
              if(self.offset == 0)
                self.cBundleRes.splice(0)
              self.cBundleRes = self.cBundleRes.concat(d.b)
            } else if(self.detail == 3){
              if(self.offset == 0)
                self.pBundleRes.splice(0)
              self.pBundleRes = self.pBundleRes.concat(d.b)

            } else if(self.detail == 4){
              if(self.offset == 0)
                self.myCards.splice(0)
              self.myCards = self.myCards.concat(d.c)
            } else if(self.detail == 5){
              if(self.offset == 0)
                self.collabCards.splice(0)
              self.collabCards = self.collabCards.concat(d.c)
            } else if(self.detail == 6){
              if(self.offset == 0)
                self.publicCards.splice(0)
              self.publicCards = self.publicCards.concat(d.c)
            }
            self.offset += 20
          }

          function n(){
            self.isLoading = false;
          }
          self.isLoading = true;
          self.$root.app.apiClient.post('subs/data/detailsch/', {s: self.terms, detail: self.detail, limit: self.limit, offset: self.offset}, w, n)

        },

        openInput: function(){
          this.inputOpen = true;
          this.localPayload = {}
          this.isLocal = false
        }

        

       
       
  },

  


}

</script>

<style scoped>


    #xButt{
        background-color: transparent !important;
        position: absolute;
        font-size: 2rem !important;
        z-index: 3
    }

  
    .delete::after{
        width: 1px;
        height: 100%
    }
     .delete::before{
        height: 1px;
        width: 100%
    }

</style>